import { useEffect, useRef } from "react";

export const useOnClickOutside = (handler, deps) => {
    const ref = useRef(null);

    useEffect(() => {
        const listener = event => {
            ref.current && !ref.current.contains(event.target) && handler(event);
        };

        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, deps ? [ref, ...deps] : [ref, handler]);

    return ref;
}